export const DEFAULT_ZOOM = 12;
export const MIN_ZOOM = 10;
export const MAX_ZOOM = 18;
export const SELECTED_STORE_ZOOM_LEVEL = 14;
export const STORES_CHUNK_SIZE = 250;
export const DEFAULT_SEARCH_RADIUS_METERS = 1500 * 10; // 15km
export const MAP_MOVEMENT_THRESHOLD_PERCENT = 20; // 20%
export const MAP_ZOOM_CHANGE_TIMEOUT = 1000; // 1 sec
export const MAP_POSITION_CHANGE_TIMEOUT = 1500; // 1.5 sec
